import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Divider, makeStyles, Tab, Typography } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';

import { useSortingCenterById } from 'hooks';
import Loading from 'components/Loading';
import { fonts } from 'theme';
import { AppContext } from 'context';
import StreamList from './StreamList';
import { WastageList } from './WastageList';
import MaterialList from './MaterialList';
import { SortingCenterInfo } from './SortingCenterInfo';
import NoPaperPageContent from '../../../components/Generic/NoPaperPageContent';

const useStyles = makeStyles({
  page: {
    width: '100%',
    maxWidth: '942px',
  },
  label: {
    fontWeight: 600,
    marginRight: '16px',

    '&:after': {
      content: '" :"',
    },
  },
  marginTopDivider: {
    marginTop: '6em',
  },
  tabPanel: {
    padding: '24px 0',
    fontFamily: fonts.secondary,
    width: '100%',
  },
});

enum TabLabels {
  Information = 'information',
  Materials = 'materials',
  Streams = 'streams',
  Wastage = 'wastage',
}

const MySortingCenter: React.FC = () => {
  const classes = useStyles();

  const { t } = useTranslation('translation', { keyPrefix: 'sortingCenters' });

  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();
  const sortingCenterId = sortingCenter?.['@id'].split('/')[sortingCenter?.['@id'].split('/').length - 1];
  const { value: sortingCenterFromHook, loading } = useSortingCenterById(sortingCenterId ?? null);

  const [selectedTab, setSelectedTab] = useState(TabLabels.Information);

  return (
    <>
      <NoPaperPageContent title={t('show.title')}>
        {loading ? (
          <Loading />
        ) : (
          sortingCenterFromHook && (
            <Box className={classes.page}>
              <Divider className={classes.marginTopDivider} />
              <Box display="flex" paddingTop="26px" paddingBottom="26px">
                <Box marginRight="200px">
                  <Typography>
                    <span className={classes.label}>{t('code')}</span>
                    {sortingCenterFromHook.code}
                  </Typography>
                </Box>
                <Typography>
                  <span className={classes.label}>{t('name')}</span>
                  {sortingCenterFromHook.name}
                </Typography>
              </Box>
              <Divider />
              <Box display="flex" paddingTop="26px" paddingBottom="52px" marginRight="200px">
                <Typography>
                  <span className={classes.label}>{t('city')}</span>
                  {sortingCenterFromHook.city}
                </Typography>
              </Box>

              <TabContext value={selectedTab}>
                <TabList
                  value={selectedTab}
                  onChange={(e, newValue) => {
                    setSelectedTab(newValue);
                  }}
                  indicatorColor="primary"
                  textColor="primary"
                >
                  <Tab label={t('tabs.information')} value={TabLabels.Information} />
                  <Tab label={t('tabs.materials')} value={TabLabels.Materials} />
                  <Tab label={t('tabs.streams')} value={TabLabels.Streams} />
                  <Tab label={t('tabs.wastage')} value={TabLabels.Wastage} />
                </TabList>
                <Divider />
                <TabPanel value={TabLabels.Information} className={classes.tabPanel}>
                  <SortingCenterInfo />
                </TabPanel>
                <TabPanel value={TabLabels.Materials} className={classes.tabPanel}>
                  <MaterialList />
                </TabPanel>
                <TabPanel value={TabLabels.Streams} className={classes.tabPanel}>
                  <StreamList />
                </TabPanel>
                <TabPanel value={TabLabels.Wastage} className={classes.tabPanel}>
                  <WastageList />
                </TabPanel>
              </TabContext>
            </Box>
          )
        )}
      </NoPaperPageContent>
    </>
  );
};
export default MySortingCenter;
